module.exports = __webpack_public_path__ + "static/metal-ef90fed9b379d8fd2f79f713e805a9e3.mp3";